import { NgModule } from '@angular/core';
import { LibBankIconV2Component } from './lib-bank-icon-v2.component';

@NgModule({
  declarations: [LibBankIconV2Component],
  imports: [],
  exports: [LibBankIconV2Component],
})
export class LibBankIconV2Module {}
